import React from "react";
import { NavLink } from "react-router-dom";
import {
    ShieldCheck,
    HandCoins,
    FlaskConical,
    LineChart,
    ListChecks,
    ClipboardCheck,
    FileArchive,
    FileText,
    CalendarDays,
    LogOut,
} from "lucide-react";
import { logout, getUser } from "@/lib/auth";
import { cn } from "@/lib/utils";
import { BrandLogo } from "@/components/rikkus/BrandLogo";

const NAV = [
    { to: "/audit", label: "Auditoría", icon: ShieldCheck, testid: "sidebar-nav-audit" },
    { to: "/offers", label: "Ofertas", icon: HandCoins, testid: "sidebar-nav-offers" },
    { to: "/simulate", label: "Simulación", icon: FlaskConical, testid: "sidebar-nav-simulate" },
    { to: "/bet365", label: "Bet365", icon: LineChart, testid: "sidebar-nav-bet365" },
    { to: "/manual-results", label: "Orden manual", icon: ClipboardCheck, testid: "sidebar-nav-manual-results" },
    { to: "/bris-charts", label: "Charts BRIS", icon: FileArchive, testid: "sidebar-nav-bris-charts" },
    { to: "/bris-pp", label: "PP Data Files", icon: FileText, testid: "sidebar-nav-bris-pp" },
    { to: "/review", label: "Revisión", icon: ListChecks, testid: "sidebar-nav-review" },
    {
        label: "Racing Calendar",
        icon: CalendarDays,
        testid: "sidebar-nav-racing-calendar",
        external: `${process.env.REACT_APP_BACKEND_URL || ""}/api/racing-calendar/view`,
    },
];

export const Sidebar = () => {
    const user = getUser();
    const doLogout = () => {
        logout();
        window.location.href = "/login";
    };
    return (
        <aside
            data-testid="app-sidebar"
            className="hidden md:flex md:flex-col md:w-56 lg:w-60 border-r border-border bg-card/60 backdrop-blur-sm sticky top-0 h-screen"
        >
            <div className="h-14 flex items-center gap-2 px-4 border-b border-border">
                <BrandLogo
                    variant="auto"
                    imgClassName="h-6 w-auto"
                    data-testid="sidebar-brand-logo"
                />
                <span className="ml-auto text-[9px] font-mono text-muted-foreground uppercase tracking-widest">
                    panel
                </span>
            </div>
            <nav className="flex-1 py-3 px-2 space-y-1">
                {NAV.map((item) => {
                    const Icon = item.icon;
                    if (item.external) {
                        return (
                            <a
                                key={item.external}
                                href={item.external}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={item.testid}
                                className="flex items-center gap-2 px-2.5 py-1.5 rounded-md text-sm text-muted-foreground hover:text-foreground hover:bg-muted/40 transition-colors duration-150 border-l-2 border-transparent pl-2"
                            >
                                <Icon className="h-4 w-4" strokeWidth={2} />
                                <span>{item.label}</span>
                            </a>
                        );
                    }
                    return (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={item.testid}
                            className={({ isActive }) =>
                                cn(
                                    "flex items-center gap-2 px-2.5 py-1.5 rounded-md text-sm transition-colors duration-150",
                                    isActive
                                        ? "bg-muted/60 text-foreground font-medium border-l-2 border-primary pl-2"
                                        : "text-muted-foreground hover:text-foreground hover:bg-muted/40 border-l-2 border-transparent pl-2"
                                )
                            }
                        >
                            <Icon className="h-4 w-4" strokeWidth={2} />
                            <span>{item.label}</span>
                        </NavLink>
                    );
                })}
            </nav>
            <div className="border-t border-border p-2">
                <div className="px-2 py-1 text-xs text-muted-foreground truncate" data-testid="sidebar-user-email">
                    {user?.email || "—"}
                </div>
                <button
                    data-testid="sidebar-logout-button"
                    onClick={doLogout}
                    className="w-full mt-1 flex items-center gap-2 px-2.5 py-1.5 rounded-md text-sm text-muted-foreground hover:text-foreground hover:bg-muted/40 transition-colors"
                >
                    <LogOut className="h-4 w-4" />
                    <span>Salir</span>
                </button>
                <div className="px-2 mt-2 text-[9px] font-mono uppercase tracking-widest text-muted-foreground/70">
                    Precisión en movimiento
                </div>
            </div>
        </aside>
    );
};
